export default "__VITE_ASSET__BFHtkRVl__"